import { Flame } from 'lucide-react';
import { Link } from 'react-router-dom';

import { LinkedInIcon } from '@/components/icons';
import { Container } from '@/components/ui';

const LINKEDIN_URL = 'https://www.linkedin.com/in/adityakqumar/';

const LINK_GROUPS: { heading: string; links: { label: string; href: string }[] }[] = [
  {
    heading: 'Prepare',
    links: [
      { label: 'Resume analysis', href: '/resume' },
      { label: 'Practice interviews', href: '/interviews' },
      { label: 'Coding practice', href: '/coding' },
      { label: 'Company prep', href: '/companies' },
      { label: 'Leaderboard', href: '/leaderboard' },
    ],
  },
  {
    heading: 'Learn',
    links: [
      { label: 'Roadmaps', href: '/roadmap' },
      { label: 'AI mentor', href: '/mentor' },
      { label: 'How it works', href: '/#how-it-works' },
      { label: 'FAQ', href: '/#faq' },
    ],
  },
  {
    heading: 'Connect',
    links: [{ label: 'LinkedIn', href: LINKEDIN_URL }],
  },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 border-t border-[var(--border-subtle)] bg-[var(--surface-sunken)]">
      <Container className="py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <Link to="/" className="mb-4 inline-flex items-center gap-2.5">
              <span className="from-brand-500 to-accent-500 grid size-8 place-items-center rounded-lg bg-gradient-to-br">
                <Flame className="size-4 text-white" aria-hidden="true" />
              </span>
              <span className="font-semibold tracking-tight">
                Go<span className="text-brand-500 dark:text-brand-400">Interview</span>
              </span>
            </Link>
            <p className="max-w-xs text-sm text-[var(--text-secondary)]">
              Crack any interview with AI-guided practice — resumes, mocks, coding and roadmaps.
            </p>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="mt-5 inline-flex items-center gap-2 rounded-lg text-sm text-[var(--text-secondary)] transition-colors hover:text-[var(--text-primary)]"
            >
              <LinkedInIcon className="size-4" />
              LinkedIn
            </a>
          </div>

          {LINK_GROUPS.map((group) => (
            <nav key={group.heading} aria-labelledby={`footer-${group.heading}`}>
              <h2
                id={`footer-${group.heading}`}
                className="mb-3 text-xs font-semibold tracking-wider text-[var(--text-muted)] uppercase"
              >
                {group.heading}
              </h2>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="rounded text-sm text-[var(--text-secondary)] transition-colors hover:text-[var(--text-primary)]"
                      {...(link.href.startsWith('http')
                        ? { target: '_blank', rel: 'noreferrer noopener' }
                        : {})}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-[var(--border-subtle)] pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-[var(--text-muted)]">© {year} GoInterview</p>
        </div>
      </Container>
    </footer>
  );
}
